import React, { useRef} from 'react';
import styled from "styled-components";
import {getCssSizeValue, setCssVars} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import CommonText from "@/components/common/Text";
import useIsomorphicLayoutEffect from "@/hooks/useIsomorphicLayoutEffect";
import {useViewportWidth} from "@/hooks/useViewport";
import CopyToolTip from "@/components/ToolTip/Variants/CopyToolTip";
import {TOOLTIP_POSITION} from "@/components/ToolTip/BaseToolTip";
import SquaresBackground from "@/components/common/SquaresBackground";
import {useRouter} from "next/router";

const Wrapper = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	//background-color: ${({ theme }) => theme.colors.white};
	width: 100%;
	overflow: hidden;
	&.has-link {
		cursor: pointer;
	}
	min-height: ${getCssSizeValue(232, BREAKPOINTS.DESKTOP)};
	padding: 
			${getCssSizeValue(52, BREAKPOINTS.DESKTOP)} 
			${getCssSizeValue(72, BREAKPOINTS.DESKTOP)}
			${getCssSizeValue(42, BREAKPOINTS.DESKTOP)}
			${getCssSizeValue(48, BREAKPOINTS.DESKTOP)}
	;
	.bg{
		z-index: 0;
	}
	
	> *{
		z-index: 1;
	}
`

const Row = styled.div`
	--offset: 0;
	--spacing-r:  ${getCssSizeValue(88, BREAKPOINTS.DESKTOP)};
	--offset-y: 0%;
	position: relative;
    display: flex;
	width: 100%;
	align-items: end;
	height: 100%;
	justify-content: space-between;
	padding-right: var(--spacing-r);
	flex-wrap: wrap;
	
	&:before{
		content: ' ';
		position: absolute;
		top: calc(var(--offset-y) * -1);
		right: 0;
		width: calc(100% - var(--offset, 0) - 10px);
		background-color: ${({ theme }) => theme.colors.richBlack};
		height: 1px;
	}

    &:after{
        content: ' ';
        position: absolute;
        top: calc(var(--offset-y) * -1);
        right: 0;
        width: 1px;
        background-color: ${({ theme }) => theme.colors.richBlack};
        height: calc(90% + var(--offset-y));
    }
	
	svg{
		bottom: 10%;
		right: 0;
		position: absolute;
		width:  calc(var(--spacing-r) * 0.9);
		transform: translateY(50%);
		
		path{
			fill: ${({ theme }) => theme.colors.richBlack};
		}
	}
	
`
const Text = styled(CommonText)`
	display: flex;
	column-gap: 6px;
    overflow: hidden;
	&.krs{
		cursor: pointer;
	}
	span{
		color: ${({ theme }) => theme.colors.chilliRed};
	}
`

const WhiteBlock = ({ className='', title ='', krs='', helper1='', helper2='', url, ...props}) => {
	const RowRef = useRef()
	const HeaderRef = useRef()
	const vWidth = useViewportWidth()

	useIsomorphicLayoutEffect(() => {
		const {width} = HeaderRef.current.getBoundingClientRect()
		setCssVars(RowRef.current, {
			offset: `${width}px`
		})
	},[vWidth])
	const router = useRouter();
	const handleClick = () => {
		if(url) {
			router.push(url);
		}
	}
	return (
		<Wrapper onClick={handleClick} className={`${className} ${url ? 'has-link' : ''}` } {...props}>
			<Text ref={HeaderRef} className="uppercase typo-borna typo-borna-81" color="richBlack">
				{helper1}
			</Text>
			<Row ref={RowRef}>
				<Text className=" typo-borna typo-borna-78" color="periwinkle">
					{helper2}
				</Text>
				<Text className="krs typo-borna typo-borna-80" color="richBlack">
					{title}
					<CopyToolTip
						copyValue={krs}
						position={TOOLTIP_POSITION.TOP_END}
					>
						{krs}
					</CopyToolTip>
				</Text>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79 8" fill="none">
					<path
						d="M1.02912 3.91918C0.833862 4.11444 0.833862 4.43103 1.02912 4.62629L4.21111 7.80827C4.40636 8.00353 4.72295 8.00353 4.91821 7.80827C5.11347 7.61301 5.11347 7.29642 4.91821 7.10116L2.08978 4.27274L4.91821 1.44431C5.11347 1.24905 5.11347 0.932464 4.91821 0.737202C4.72295 0.541939 4.40636 0.541939 4.21111 0.737202L1.02912 3.91918ZM78.8438 3.77274L1.38268 3.77274V4.77274L78.8438 4.77274V3.77274Z"
					/>
				</svg>
			</Row>
			<SquaresBackground />
		</Wrapper>
	);
};

export default WhiteBlock;
